module.exports = __webpack_public_path__ + "images/category_lp/art_work/new/store_images/1@2x_08c9f529160a930e96bd05aacfb42ac7.png";